import { getEnabledElement, StackViewport, BaseVolumeViewport } from '@cornerstonejs/core';
import { StackScrollTool } from '@cornerstonejs/tools/tools';
import seriesScroll from './seriesScroll';


/**
 * The SeriesStackScrollMouseWheelTool is a tool that allows the user to scroll through a
 * stack of images and through the series using the mouse wheel.
 * Supports both StackViewport and VolumeViewport.
 */
class SeriesStackScrollMouseWheelTool extends StackScrollTool {

  static toolName;
 
  _configuration;

  constructor(
    toolProps = {},
    defaultToolProps = {
      supportedInteractionTypes: ['Mouse', 'Touch'],
      configuration: {
        invert: false,
        debounceIfNotLoaded: true,
        loop: false,
        scrollSlabs: false,
        seriesScrollCallback: () => {console.log('default callback');}
      },
    }
  ) {
    super(toolProps, defaultToolProps);
  }

  mouseWheelCallback(evt) {
    const { wheel, element } = evt.detail;
    const { viewport } = getEnabledElement(element);
    const { direction } = wheel;
    const { invert } = this.configuration;
    const delta = direction * (invert ? -1 : 1);

    const targetId = this.getTargetId(viewport);
    const volumeId = targetId.split('volumeId:')[1];

    // Fire series scroll callback for both stack and volume viewports
    this.configuration.seriesScrollCallback(viewport, delta);

    seriesScroll(viewport, {
      delta,
      debounceLoading: this.configuration.debounceIfNotLoaded,
      loop: this.configuration.loop,
      volumeId,
      scrollSlabs: this.configuration.scrollSlabs,
    });
  }
}

SeriesStackScrollMouseWheelTool.toolName = 'SeriesStackScrollMouseWheel';
export default SeriesStackScrollMouseWheelTool;
